const env = process.env.NODE_ENV === 'production' ? 'prod' : 'dev'
const imgHostConfig = {
  prod: 'http://172.17.18.177:28081/',
  dev: 'http://172.17.18.177:28081/'
}
// 开发
// const urlHostConfig = {
//   prod: 'http://172.17.18.177:18081',
//   dev: 'http://172.17.18.177:18081'
// }
// //测试
const urlHostConfig = {
  prod: 'http://172.17.18.177:28081',
  dev: 'http://172.17.18.177:28081'
}

const parmarsData = {
  sign: '1'
}
export default {
  onOff: false,
  serverPubKey: 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCh5QRBjoUOOwcdSAuHup8GuC19szzV7MY9skA2riqMZOWYa9Mj59Utl6SG9ZM1sJJLtAzMMDJIuRCZrka0KYlH_CP1WfyZC9jbhurL7Vzg6',
  env,
  urlHost: urlHostConfig[env],
  imgHost: imgHostConfig[env], // 图片路径
  validConfig: true, // true  打开自定义验证 false 使用框架默认验证
  waterOff: true, // 是否打开水印,
  routerList: ['login', 'loading-login', 'loading-qiye-login', 'login-tenant', 'forget-psd', 'sys-config-owner-manage', 'ssologin', 'materialSsoLogin']
}
